const initState = {
  Contract: null,
  getContract: null,
  existSchoolContractCid: null,
  Loading: false,
  schoolAdminData: {},
};

const ContractReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_SCHOOL_ADMIN_DATA":
      return {
        ...state,
        schoolAdminData: action.payload,
      };
    case "EXIST-CONTRACT-CID":
      return {
        ...state,
        existSchoolContractCid: action.payload,
      };
    case "GETContractByID":
      return {
        ...state,
        Contract: action.payload,
      };
    case "FIND_CONTRACT":
      return {
        ...state,
        getContract: action.payload,
      };
    case "SET_IS_LOADING":
      return {
        ...state,
        Loading: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default ContractReducer;
